export default __webpack_public_path__ + "static/2-cdf70ada555886176425d68739f1c507.png";